import styled from "@emotion/styled";
import MUITextField, { type TextFieldProps as MUITextFieldProps } from "@mui/material/TextField";
import React, { forwardRef } from "react";

import { Colors } from "../../constants/Colors";
import { Paragraph } from "../../constants/Typography";

export type TextFieldProps = MUITextFieldProps & {
  height?: string | number;
  width?: string | number;
};

const StyledTextField = styled(MUITextField)<{ height?: string | number; width?: string | number }>`
  &.MuiTextField-root {
    width: ${(props) => props.width || (props.fullWidth ? "100%" : props.size === "small" ? "200px" : "412px")};
  }
  & .MuiInput-underline:after {
    border-bottom-color: green;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: ${Colors.Border.main};
    }
    &:hover fieldset {
      border-color: ${Colors.Border.main};
    }
    &.Mui-focused fieldset {
      border-color: ${Colors.Secondary.main};
    }
  }
  & .Mui-error input {
    background: ${Colors.Error.light};
    border: 1px solid ${Colors.Error.main};
    border-radius: 4px;
  }
  & .MuiInputBase-input {
    padding: 0 14px;
    height: ${(props) => props.height || (props.size === "small" ? "36px" : "48px")};
  }
  & .MuiInputBase-inputMultiline {
    padding: 0;
  }
`;

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(({ height, width, ...props }, ref) => {
  return (
    <StyledTextField
      {...props}
      height={height}
      width={width}
      key={props.name}
      ref={ref}
      sx={{ fontSize: props.size === "small" ? Paragraph.M : Paragraph.L, ...props.sx }}
    />
  );
});

TextField.displayName = "TextField";
export default TextField;
